import React from 'react';
import PropTypes from 'prop-types';

import { Alert, Modal, Button, List } from 'antd';
import { Form as FormikForm, FormItem } from 'formik-antd';

import { SingleFileUpload } from 'components/form/upload';
import { getUrlFromEvent } from 'utils/form';

import { Fieldset } from 'components/form';
import StagePropTypes from './prop-types';

import { DB_PREFIX } from './constants';

const Form = ({
  isSubmitting,
  values,
  validateStatus,
  help,
  setFieldValue,
  uploadTo,
  children,
}) => {
  const field01 = `${DB_PREFIX}.confirmationDocumentURL01`;
  const file01 = values[DB_PREFIX].confirmationDocumentURL01
    ? {
        name: 'Address Document',
        url: values[DB_PREFIX].confirmationDocumentURL01,
      }
    : undefined;

  const field02 = `${DB_PREFIX}.confirmationDocumentURL02`;
  const file02 = values[DB_PREFIX].confirmationDocumentURL02
    ? {
        name: 'Address Document',
        url: values[DB_PREFIX].confirmationDocumentURL02,
      }
    : undefined;

  const documentList = [
    "UK/EU Mortgage Statement*",
    'UK Council Tax Bill*',
    'UK/EU Bank Statement**',
    'UK/EU Credit Car Statement **',
    'Utility Bill**',
    '',
    '* issued in last 12 months',
    '** issued in last 3 months'
  ];

  const documentListModal = () => {
    Modal.info({
      title: 'Document List',
      content: (
        <List
          dataSource={documentList}
          size="small"
          renderItem={(item) => <List.Item>{item}</List.Item>}
        />
      ),
      onOk() {},
    });
  };

  return (
    <FormikForm layout="vertical">
      <Alert
        message="Upload two documents to confirm your address"
        description={
          <div>
            Photos of your documents is OK
            <Button
              type="link"
              onClick={documentListModal}
              style={{
                padding: 0,
                marginLeft: 'var(--margin-h)',
              }}
            >
              (see attached list for valid documents)
            </Button>
          </div>
        }
        type="info"
        showIcon
      />
      <Fieldset>
        <FormItem
          name={field01}
          label=""
          validateStatus={validateStatus.confirmationDocumentURL01}
          help={help.confirmationDocumentURL01}
        >
          <SingleFileUpload
            className="ant-upload ant-upload-drag"
            title="First address confirmation document"
            file={file01}
            uploadTo={uploadTo}
            multiple={false}
            showUploadList
            disabled={file01 != null || isSubmitting}
            onClear={() => {
              setFieldValue(field01, null);
            }}
            onChange={(e) => {
              setFieldValue(field01, getUrlFromEvent(e));
            }}
          />
        </FormItem>
        <FormItem
          name={field02}
          label=""
          validateStatus={validateStatus.confirmationDocumentURL02}
          help={help.confirmationDocumentURL02}
        >
          <SingleFileUpload
            className="ant-upload ant-upload-drag"
            title="Second address confirmation document"
            file={file02}
            uploadTo={uploadTo}
            multiple={false}
            showUploadList
            disabled={file02 != null || isSubmitting}
            onClear={() => {
              setFieldValue(field02, null);
            }}
            onChange={(e) => {
              setFieldValue(field02, getUrlFromEvent(e));
            }}
          />
        </FormItem>
      </Fieldset>

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  uploadTo: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  values: StagePropTypes.isRequired,
  help: StagePropTypes.isRequired,
  validateStatus: StagePropTypes.isRequired,
};

Form.defaultProps = {
  children: null,
  isSubmitting: false,
};

export default Form;
